import type { ReactNode } from 'react'

import { Seo } from '@/components/generals/seo'
import CoinflipGame from '@/components/games/coinflip-game'
import { GameHeader } from '@/components/games/game-ui'
import { GAMES } from '@/constants/site'

const game = GAMES[0]

const CoinflipPage = (): ReactNode => {
    return (
        <>
            <Seo title='Coinflip' description='Fire or Donut: pick a side and flip for 1.96× your DonutSMP money. Bets from $10K to $15B.' />
            <GameHeader title={game.name} subtitle={game.subtitle} />
            <CoinflipGame />
        </>
    )
}

export default CoinflipPage
